import {useSyncExternalStore} from 'react';

import {config} from '../config';

export const useDirectJoin = () =>
    useSyncExternalStore(
        onChange => config.subscribe('join', onChange),
        () => config.get('join'),
    );
